import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

function Boton({ onProcesar, loading = false, disabled = false }) {
  return (
    <div className="app-boton">
      <Button
        variant="contained"
        color="success"
        onClick={onProcesar}
        disabled={disabled}
        size="large"
        fullWidth
        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
      >
        {loading ? 'Procesando...' : 'Procesar'}
      </Button>
    </div>
  );
}

function BotonLimpiar({ onProcesar, loading = false, disabled = false }) {
  return (
    <div className="app-boton">
      <Button
        variant="contained"
        color="error"
        onClick={onProcesar}
        disabled={disabled}
        size="large"
        fullWidth
      >
        Limpiar
      </Button>
    </div>
  );
}

export { Boton, BotonLimpiar };
